var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminRespondeL(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 235.83,
    viewBox: "0 0 268 235.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AdminRespondeL",
    transform: "translate(4411.094 -444.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    fill: "#1c1a24",
    d: "M-4203.092,632.119c-2.32,5.116-5.7,10.574-11.2,11.727a13.026,13.026,0,0,1-9.824-2.411,34.428,34.428,0,0,1-7.243-7.4c-.138,10.835-8.683,20.973-19.338,22.943s-22.261-4.441-26.266-14.509a24.114,24.114,0,0,1-21.518,16.41,24.114,24.114,0,0,1-22.688-14.745l-4.664,1.752a15.1,15.1,0,0,1-15.7,2.247,15.1,15.1,0,0,1-8.665-13.283,49.457,49.457,0,0,1-25.334,9.519l9.689-26.288-18.456-12.009c-8.148-7.883-12.812-17.335-7.535-32.409-4.859-.084-12.562-2.261-19.264-8.793,15.116-13.692,28.464-51.406,32.869-60.352s10.493-17.586,19.543-22.957,21.543-6.8,30.664-1.531l-1.428-1.171a174.761,174.761,0,0,1,72.82-32.363c12.079-2.288,24.705-3.265,36.558,0,22.193,6.113,38.211,26.419,45.432,48.278s5.841,43.763,7.133,58.42c.491,5.537,4.149,10.517,8.639,13.793a22.134,22.134,0,0,0,15.771,4.018,38.305,38.305,0,0,1-25.58,20.268,23.269,23.269,0,0,1-5.337.612c-1.888,5.771-2.89,10.671-7.663,15.821-6.908,5.527-12.153,5.447-17.373,7.855Z",
    "data-name": "Path 67",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    fill: "#ff4527",
    d: "M-4188.812,591.778a107.19,107.19,0,0,0,.67-10.821c1.416-77.9-41.552-91.344-92.349-90.148-41.714.982-62.925,25.043-68.532,65q-.362,2.586-.59,5.088a34.042,34.042,0,0,0-6.387-.177c-26.563,1.786-47.24,37.01-20.937,60.163,11.962,10.53,26.457,9.276,36.842,4.717,12.35,32.287,51.84,55.366,74.57,55.366h37.054c39.508,0,64.771-42.1,46.182-76.963Z",
    "data-name": "Path 68",
    transform: "translate(-0.351 -0.742)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    cx: 8.665,
    cy: 8.665,
    r: 8.665,
    fill: "#1c1a24",
    "data-name": "Ellipse 18",
    transform: "translate(-4297.454 563.615)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    cx: 14.028,
    cy: 14.028,
    r: 14.028,
    fill: "#e4e3c2",
    "data-name": "Ellipse 19",
    transform: "translate(-4303.515 617.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    cx: 8.665,
    cy: 8.665,
    r: 8.665,
    fill: "#1c1a24",
    "data-name": "Ellipse 20",
    transform: "translate(-4222.795 563.615)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-4351.468 553.114)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 36.178,
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Line 6",
    transform: "translate(0 17.116)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    x1: 12.562,
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "Line 7",
    transform: "translate(164.307 17.116)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    opacity: 0.2,
    transform: "translate(34.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    fill: "#e4e3c2",
    d: "M-4250.3,579.751c0,19.214-14.545,34.79-32.481,34.79s-32.485-15.577-32.485-34.79,14.545-24.869,32.485-24.869S-4250.3,560.537-4250.3,579.751Z",
    "data-name": "Path 69",
    transform: "translate(4315.265 -554.882)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    opacity: 0.2,
    transform: "translate(113.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    fill: "#e4e3c2",
    d: "M-4169.956,579.751c0,19.214-14.545,34.79-32.486,34.79s-32.482-15.577-32.482-34.79,14.543-24.869,32.482-24.869S-4169.956,560.537-4169.956,579.751Z",
    "data-name": "Path 70",
    transform: "translate(4234.924 -554.882)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    fill: "#e4e3c2",
    d: "M-4282.781,556.85c20.536,0,30.516,7.491,30.516,22.9,0,18.1-13.688,32.822-30.516,32.822s-30.516-14.725-30.516-32.822c0-15.409,9.983-22.9,30.516-22.9m0-1.968c-17.938,0-32.483,5.655-32.483,24.869s14.545,34.79,32.483,34.79,32.483-15.577,32.483-34.79-14.545-24.869-32.483-24.869Z",
    "data-name": "Path 71",
    transform: "translate(4349.934 -554.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    fill: "#e4e3c2",
    d: "M-4202.442,556.85c20.534,0,30.516,7.491,30.516,22.9,0,18.1-13.688,32.822-30.516,32.822s-30.515-14.725-30.515-32.822c0-15.409,9.982-22.9,30.515-22.9m0-1.968c-17.939,0-32.482,5.655-32.482,24.869s14.543,34.79,32.482,34.79,32.484-15.577,32.484-34.79-14.543-24.869-32.484-24.869Z",
    "data-name": "Path 72",
    transform: "translate(4348.649 -554.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    fill: "none",
    stroke: "#e4e3c2",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M-4251.605,571.36h0a12.706,12.706,0,0,1,18.509,0h0",
    "data-name": "Path 73",
    transform: "translate(4348.916 -555.082)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-4246.922 566.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    fill: "#ff4527",
    d: "M-4242.754,570.277l27.138,36.408-21.474,12.2",
    "data-name": "Path 74",
    transform: "translate(4244.23 -568.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    fill: "#1c1a24",
    d: "M-4237.114,620.333a1.474,1.474,0,0,1-1.283-.747,1.476,1.476,0,0,1,.554-2.013l20.019-11.372-26.136-35.067a1.475,1.475,0,0,1,.3-2.066,1.476,1.476,0,0,1,2.065.3l28.134,37.748-22.925,13.022A1.474,1.474,0,0,1-4237.114,620.333Z",
    "data-name": "Path 75",
    transform: "translate(4244.254 -568.776)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    fill: "#1c1a24",
    stroke: "#1c1a24",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    d: "M-4372.882,556.553s22.109-38.942,36.932-59.794,32.408-19.6,50.5-22.36,20,13.807,20,13.807c2.165,4.172,1.246,9.545-1.669,13.232a18.058,18.058,0,0,1-12.205,6.3,32.628,32.628,0,0,1-13.858-1.89l-.555-10.779a94.921,94.921,0,0,1-18.607,69.952c4.535-21.658,1.646-33.34-1.328-47.576-.323,8.121-.343,18.239-1.674,26.171-4.856,28.933-24.563,50.683-26.63,46.017-9.422-21.271-22.042-28.345-28.977-26.631Z",
    "data-name": "Path 76",
    transform: "translate(-24.26 16.145)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    cx: 14.028,
    cy: 14.028,
    r: 14.028,
    fill: "#e4e3c2",
    "data-name": "Ellipse 21",
    transform: "translate(-4208.046 617.21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-4261.89 630.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    fill: "#1c1a24",
    d: "M-4259.2,641.667a27.946,27.946,0,0,0,19.678,11.789,26.855,26.855,0,0,0,21.172-7.116,27.371,27.371,0,0,0,7.164-10.76c.652-1.787-2.2-2.557-2.848-.784a24.8,24.8,0,0,1-13.684,14.122,23.9,23.9,0,0,1-20.093-1.021,24.266,24.266,0,0,1-8.839-7.719c-1.07-1.556-3.63-.081-2.551,1.49Z",
    "data-name": "Path 77",
    transform: "translate(4259.464 -633.791)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminRespondeL);
export default __webpack_public_path__ + "static/media/AdminRespondeL.906221caf11e50036edec3e6aa8668ea.svg";
export { ForwardRef as ReactComponent };